// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tLQyC1YEWRPBUh {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.ACrGFzCAcyS_cn {
  display: flex;
  justify-content: center;
}
.I4ZXKj22ZJngpY {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: var(--ds-space-400, 32px);
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.ypUdiKnXlIfITh {
  display: flex;
  justify-content: center;
  padding: var(--ds-space-400, 32px);
}
.rsmfiAFXgkq_I5 {
  font-style: italic;
}
.gmZ_Crr5GHr8uW {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: var(--ds-space-400, 32px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.cwVOJRaSogUaq0 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.GYy7hamoKoppLG {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--ds-space-300, 24px);
  padding-bottom: var(--ds-space-200, 16px);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.GYy7hamoKoppLG .zZIKJkQZUefKRw {
  margin: var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
.K76HR2Wa1Iqo38 {
  padding-top: var(--ds-space-200, 16px);
  border-top: 1px solid var(--ds-border, #091e4224);
}
.K76HR2Wa1Iqo38 button {
  margin-left: var(--ds-space-100, 8px);
}
.ZBkqggwBqxpngg {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .gmZ_Crr5GHr8uW {
    padding: var(--ds-space-200, 16px);
  }
}
.Xf0TVT_LJSpwEQ label {
  display: block;
  margin-bottom: var(--ds-space-050, 4px);
}
.xspR1hfQrNWcLd {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: var(--ds-space-250, 20px);
  margin-bottom: var(--ds-space-100, 8px);
}
.e1KcKlkEdy4st3 {
  width: 36px;
  height: 36px;
  margin: var(--ds-space-025, 2px) var(--ds-space-0, 0) var(--ds-space-0, 0) 10px;
  padding: var(--ds-space-0, 0);
}
.ZzYxMFi30EGISz {
  flex-grow: 1;
  margin-top: 11px;
  margin-left: 45px;
}
.W7UV83K8Z3EtpT {
  margin-top: var(--ds-space-0, 0);
}
.cwVOJRaSogUaq0 {
  display: flex;
  justify-content: center;
  width: 100%;
}
@media only screen and (max-width: 900px) {
  .xspR1hfQrNWcLd {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .ZzYxMFi30EGISz {
    max-width: 400px;
    margin-left: var(--ds-space-0, 0);
    color: var(--ds-text-subtle, #44546f);
  }
}
.Z0skIty95uqy7V {
  width: 60px;
  height: 36px;
  margin: var(--ds-space-025, 2px) var(--ds-space-0, 0) var(--ds-space-0, 0) 10px;
  color: var(--ds-text-subtle, #44546f);
}
.RWqrzJ6EnKQiXT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 365px;
  margin-top: var(--ds-space-100, 8px);
  padding-bottom: var(--ds-space-100, 8px);
  border-bottom: 1px solid var(--ds-border, #091e4224);
  color: var(--ds-text-subtle, #44546f);
}
.XlHMkPhADsL1Hi {
  margin-top: var(--ds-space-200, 16px);
}
.V0wCeXS4eAeulV input {
  width: 296px;
}
.w99q2Oxhcd9aJZ {
  color: var(--ds-text-danger, #ae2a19);
  font-size: 12px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `tLQyC1YEWRPBUh`,
	"flexAndCenter": `ACrGFzCAcyS_cn`,
	"body": `I4ZXKj22ZJngpY`,
	"navigationAndContent": `ypUdiKnXlIfITh`,
	"learnMoreSubtle": `rsmfiAFXgkq_I5`,
	"content": `gmZ_Crr5GHr8uW`,
	"spinnerContainer": `cwVOJRaSogUaq0`,
	"header": `GYy7hamoKoppLG`,
	"title": `zZIKJkQZUefKRw`,
	"footer": `K76HR2Wa1Iqo38`,
	"formFooter": `ZBkqggwBqxpngg`,
	"formElements": `Xf0TVT_LJSpwEQ`,
	"formSection": `xspR1hfQrNWcLd`,
	"copyBtn": `e1KcKlkEdy4st3`,
	"inputDescription": `ZzYxMFi30EGISz`,
	"label": `W7UV83K8Z3EtpT`,
	"addBtn": `Z0skIty95uqy7V`,
	"origin": `RWqrzJ6EnKQiXT`,
	"origins": `XlHMkPhADsL1Hi`,
	"textfield": `V0wCeXS4eAeulV`,
	"isInvalidUrl": `w99q2Oxhcd9aJZ`
};
export default ___CSS_LOADER_EXPORT___;
